// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"b02a4f8e","199":"41370d36","436":"64f43c1f","448":"e66d9c89","675":"18f9ae4d"}[chunkId] + ".chunk.css";
};